import type { Tutorial } from '../types'

const IMG = '/images/tutorials/web/multi-profile'

export const multiProfileWebTutorial: Tutorial = {
  slug: 'multi-profile',
  platform: 'web',
  title: 'Multi-Profile Management',
  subtitle: 'All profiles in one dashboard',
  date: '2026-07-09',
  category: 'Account',
  tags: ['profiles', 'caregiver', 'family'],
  description:
    'Manage every profile under your account from /profiles — switch the active profile from the header and every feature scopes to it instantly.',
  highlights: [
    'All Profiles lists relationship, genetics status, and sharing for each person.',
    'Active profile switcher in the dashboard header.',
    'Coach, Goals, and Records all scope to the selected profile.',
  ],
  coverImage: `${IMG}/01-all-profiles.png`,
  sections: [
    {
      heading: 'All Profiles',
      paragraphs: [
        '**All Profiles** shows everyone on the account — your own profile, family members, and anyone you track wellness for. Each card shows what\'s set up: genetics uploaded, records started, collaborators.',
        'Switch the active profile from the header; the dashboard reloads that person\'s Coach, Goals, and Records without a separate confirmation step.',
      ],
      image: {
        src: `${IMG}/01-all-profiles.png`,
        alt: 'All Profiles page on Livewello web',
        caption: 'All Profiles',
      },
    },
  ],
  whyMatters:
    'Caregivers and parents often manage wellness for more than one person. The web dashboard makes that explicit — one account, multiple profiles, instant switching from any page.',
  relatedSlugs: ['profile-sharing', 'wellness-coach'],
  meta: {
    description: 'Multi-profile management on Livewello web: All Profiles and active profile switching.',
    ogImage: `${IMG}/01-all-profiles.png`,
  },
}
